export const validatorPattern = (type: string, name?: string) => {
  switch (type){
    case 'email': // 邮件
      return [{ pattern: "^[A-Za-z0-9-._]+@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,6})$", message: lang[`请输入正确的${name || '邮箱地址'}`] }]
    case 'idNo': // 身份证 15位：440253850213582 18位 440102198001021230
      return [{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: lang['请输入正确的身份证号'] }]
    case 'phone': // 
      return [{ pattern: /^[1][2-9][0-9]{9}$/, message: lang[`请输入正确的${name || '手机号'}`] }]
    case 'en': // 
      return [{ pattern: "^[a-zA-Z]+$", message: lang['只能输入英文字母'] }]
    default:
      return []
  }
}